module.exports = {
	"classes": [
		"app-modernization-page",
		"header-dark"
	],
	"title": "App Modernization",
	"metas": {
		"description": "Get a head start on your legacy software modernization initiative with the right identity platform."
	},
	"opengraph": {
		"og:title": "App Modernization",
		"og:description": "Get a head start on your legacy software modernization initiative with the right identity platform.",
		"og:url": "https://auth0.com/app-modernization",
		"og:image": "https://cdn.auth0.com/website/assets/pages/app-modernization/img/appmod-twittercard-8675704b3e.png",
		"og:image:secure_url": "https://cdn.auth0.com/website/assets/pages/app-modernization/img/appmod-twittercard-8675704b3e.png"
	},
	"twittercard": {
		"twitter:title": "App Modernization",
		"twitter:description": "Get a head start on your legacy software modernization initiative with the right identity platform.",
		"twitter:image": [
			{
				"src": "https://cdn.auth0.com/website/assets/pages/app-modernization/img/appmod-twittercard-8675704b3e.png"
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/app-modernization/metadata.json
// module id = 1363
// module chunks = 0